export let SortDirections = /*#__PURE__*/function (SortDirections) {
  SortDirections["Ascending"] = "asc";
  SortDirections["Descending"] = "desc";
  return SortDirections;
}({});
//# sourceMappingURL=sort-directions.js.map